/**
 * @fileoverview `<SectionHeader>` — the ONE section heading group (LIFE-SHORTLISTED-001 P5.3).
 *
 * An optional eyebrow (`.text-overline`), the section's h2 (`.section-heading`) and an optional
 * subheading (`.section-description`), inside `<header class="section-heading-group">`. Nine
 * sections in this package hand-rolled the same group, and none could carry an eyebrow — which the
 * block schema's section header group (`eyebrow` / `heading` / `subheading`) needs every section to
 * render the same way. The prop names ARE that group's field names.
 *
 * Renders nothing when it has nothing to say, so a section without a heading stays unlabelled
 * rather than gaining an empty `<header>`.
 *
 * @module @puffin-core/marketing-shell/components/SectionHeader
 */

import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {string} [props.eyebrow] - small uppercase kicker above the heading
 * @param {string} [props.heading] - the section's h2
 * @param {string} [props.subheading] - one supporting line under the heading
 * @param {string} [props.headingId] - id for the h2, when the section is labelled by it
 * @returns {React.JSX.Element|null}
 */
export function SectionHeader({ eyebrow, heading, subheading, headingId }) {
  if (!eyebrow && !heading && !subheading) {
    return null;
  }
  return (
    <header className="section-heading-group">
      {eyebrow ? <p className="text-overline">{eyebrow}</p> : null}
      {heading ? (
        <h2 id={headingId} className="section-heading">
          {heading}
        </h2>
      ) : null}
      {subheading ? <p className="section-description">{subheading}</p> : null}
    </header>
  );
}

SectionHeader.propTypes = {
  eyebrow: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  headingId: PropTypes.string,
};

export default SectionHeader;
